// Text
const $White = "rgb(255, 255, 255)";
const $WhiteA12 = "rgba(255, 255, 255, 0.12)";
const $Black = "rgb(0, 0, 0)";
const $Gray = "rgb(139, 138, 153)";
const $GrayA12 = "rgba(139, 138, 153, 0.12)";
const $GrayA50 = "rgba(139, 138, 153, 0.5)";
const $GrayL80 = "rgb(197, 194, 209)";
const $GrayL95 = "rgb(240, 241, 242)";
const $Green = "rgb(78, 168, 72)";
const $Main = "rgb(49, 51, 66)";
const $MainText = "rgb(75, 72, 102)";
const $Focus = "rgb(138, 46, 230)";
const $FocusA25 = "rgba(138, 46, 230, 0.25)";
const $Blur = "rgba(139, 138, 153, 0.25)";
const $Good = "rgb(52, 168, 69)";
const $Warn = "rgb(234, 169, 69)";
const $Error = "rgb(235, 71, 46)";
const $DialogGb = "rgb(245, 246, 247)";
const $Purple = "rgb(98, 73, 213)";

// UI
const $UILine = "rgba(139, 138, 153, 0.25)";
const $CurrentTopbar = "rgb(239, 239, 241)";

// Pressure
const $Over1 = "rgb(212, 224, 244)";
const $Over5 = "rgb(169, 194, 232)";
const $Over10 = "rgb(91, 177, 221)";
const $Over30 = "rgb(82, 133, 209)";
const $Over60 = "rgb(39, 102, 198)";
const $Over90 = "rgb(29, 77, 149)";
const $Over120 = "rgb(20, 51, 99)";

// Average Pressure
const $Level0 = "#FFFFFF";
const $Level1 = "#DFDAFC";
const $Level2 = "#A49DFD";
const $Level3 = "#9276D1";
const $Level4 = "#573EC4";
const $Level5 = "#3C0178";

// Event
const $EventStirring = "rgb(38, 179, 52)";
const $EventSittingup = "rgb(246, 176, 0)";
const $EventLeaving = "rgb(238, 69, 60)";
const $EventOutofBed = "rgb(238, 69, 60)";
const $EventReposition = "rgb(148, 171, 216)";
const $EventImmobile = "rgb(70, 51, 189)";
const $EventReset = "rgb(139, 108, 170)";
const $EventNurseMode = "rgb(0, 113, 188)";
const $Acthigh = "rgb(138, 46, 230)";
const $ActLow = "rgb(197, 194, 209)";
const $Actnull = "rgb(241, 240, 245)";

// Alpha Colors
const $Blacka4 = "rgba(0, 0, 0, 0.04)";
const $Blacka12 = "rgba(0, 0, 0, 0.12)";
const $Whitea0 = "rgba(255, 255, 255, 0)";
const $Whitea50 = "rgba(255, 255, 255, 0.5)";

// Misc
const $Header = "rgb(250, 250, 250)";
const $ContentBackground = "#FFFFFF";
const $SideBar = "rgb(235, 236, 237)";
const $Border1 = "rgb(245, 246, 247)";
const $BorderInner = "rgba(139, 138, 153, 0.5)";
const $TimerBox = "rgb(163, 161, 179)";

// Patient detail
const $Resting = "rgb(227, 220, 231)";
const $Moving = "rgb(122, 192, 190)";
const $OffBed = "rgb(138, 46, 230)";
const $Unknown = "rgb(255, 255, 255)";

// Fonts
const $Primary = {
  fontfamily:
    '"Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sansserif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontstyle: "normal",
  fontvariant: "normal",
  fontweight: 500,
};

const $Secondary = {
  fontfamily:
    '"Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sansserif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontsize: "28px",
  fontstyle: "normal",
  fontvariant: "normal",
  fontweight: 300,
};

const $Title = {
  fontfamily:
    '"Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sansserif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontsize: "28px",
  fontstyle: "normal",
  fontvariant: "normal",
  fontweight: 400,
};

const $GeneralUI = {
  fontfamily:
    '"Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sansserif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontsize: "12px",
  fontstyle: "normal",
  fontvariant: "normal",
  fontweight: 400,
  lineheight: "13.2px",
};

export const styles = {
  colors: {
    White: $White,
    White_a12: $WhiteA12,
    Black: $Black,
    Gray: $Gray,
    Gray_a12: $GrayA12,
    Gray_a50: $GrayA50,
    GrayL80: $GrayL80,
    GrayL95: $GrayL95,
    Green: $Green,
    Main: $Main,
    MainText: $MainText,
    Focus: $Focus,
    Focus_a25: $FocusA25,
    Blur: $Blur,
    Good: $Good,
    Warn: $Warn,
    Error: $Error,
    DialogGb: $DialogGb,
    Purple: $Purple,
    UILine: $UILine,
    CurrentTopbar: $CurrentTopbar,
    Over_1: $Over1,
    Over_5: $Over5,
    Over_10: $Over10,
    Over_30: $Over30,
    Over_60: $Over60,
    Over_90: $Over90,
    Over_120: $Over120,
    Level_0: $Level0,
    Level_1: $Level1,
    Level_2: $Level2,
    Level_3: $Level3,
    Level_4: $Level4,
    Level_5: $Level5,
    Event_Stirring: $EventStirring,
    Event_Sittingup: $EventSittingup,
    Event_Leaving: $EventLeaving,
    Event_OutofBed: $EventOutofBed,
    Event_Reposition: $EventReposition,
    Event_Immobile: $EventImmobile,
    Event_Reset: $EventReset,
    Event_NurseMode: $EventNurseMode,
    Act_high: $Acthigh,
    Act_Low: $ActLow,
    Act_null: $Actnull,
    Blacka4: $Blacka4,
    Blacka12: $Blacka12,
    Whitea0: $Whitea0,
    Whitea50: $Whitea50,
    Header: $Header,
    ContentBackground: $ContentBackground,
    SideBar: $SideBar,
    Border1: $Border1,
    BorderInner: $BorderInner,
    TimerBox: $TimerBox,
    Resting: $Resting,
    Moving: $Moving,
    OffBed: $OffBed,
    Unknown: $Unknown,
  },
  fonts: {
    Primary: $Primary,
    Secondary: $Secondary,
    Title: $Title,
    GeneralUI: $GeneralUI,
  },
};
